import React from "react";


export const Operations = () => {
    return (
        <h2>OPERATIONS</h2>
    )
}